



























import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

@Component
export default class DatePickerMenu extends Vue {
  @Prop()
  readonly value!: string;

  @Prop({ default: "" })
  readonly icon!: string;

  @Prop({ default: "Default label" })
  readonly label!: string;

  @Prop({ default: "" })
  readonly spacing!: string;

  @Prop({ default: false })
  readonly readonly!: boolean;

  dateMenu = false;

  get formattedValue(): string {
    return DatePickerMenu.formatDate(this.value);
  }

  updateDate(value: string): void {
    this.dateMenu = false;
    this.$emit("input", value);
  }

  static formatDate(date: string): string {
    if (!date) return "";

    const [year, month, day] = date.split("-");
    return `${month}/${day}/${year}`;
  }
}
